module.exports = __webpack_public_path__ + "img/mubang-2.aff1cd66.png";